module.exports = "/_next/static/images/ChatbotsBarCharts-51a295211beb879cf867e670d5b27b51.webp";